export default {
    rings: [
        {
            id: "sustainable-future",
            fillColor: "#ccc",
            textColor: "#000",
            innerRadius: 34.5,
            outerRadius: 40.5,
            startAngle: 90,
            fontSize: 3,
            strokeColor: "#000",
            strokeWidth:0.5,
            sections: [
                { id:"csr", label: "Sustainable Future", textBias: 0.5 }
            ]
        },
        {
            id: "patient-centric",
            fillColor: "#000",
            textColor: "#fff",
            innerRadius: 28.5,
            outerRadius: 34.5,
            startAngle: 120,
            fontSize: 2.5,
            strokeColor: "#000",
            strokeWidth: 0.5,
            sections: [
                { id:"stroke", label: "NEUROLOGY" },
                { id:"cardiology", label: "CARDIOLOGY" },
                { id:"womenshealth", label: "WOMEN'S HEALTH", labelFlip: true },
                { id:"msk", label: "MSK", labelFlip: true },
                { id:"sportsmed", label: "SPORTS MED", labelFlip: true },
                { id:"lcs", label: "ONCOLOGY" }
            ]
        },



        {
            id: "solutions",
            fillColor: "#CC0000",
            textColor: "#fff",
            innerRadius: 22.75,
            outerRadius: 28.75,
            startAngle: 116.5,
            fontSize: 2.5,
            strokeColor: "#000",
            strokeWidth: 0.5,
            sections: [
                { id:"ai",label: "AI" },
                { id:"workflow",label: "WORKFLOW" },
                { id:"cybersecurity",label: "CYBERSECURITY", labelFlip: true },
                { id:"service",label: "SERVICE", labelFlip: true },
                { id:"education",label: "EDUCATION" }
            ]
        },

        {
            id: "solution-based",
            fillColor: "#CC0000",
            textColor: "#fff",
            innerRadius: 22.75,
            outerRadius: 28.75,
            startAngle: 90,
            fontSize: 2.75,
            strokeColor: "#000",
            strokeWidth: 0.5,
            sections: [
                { id:"solution-based",label: "Solution Based", textBias: 0.45 },
            ]
        },


    ]
}

export const decks  = {
    mainStory: {
        id: "mainStory",
        label: "CI Story",
        slides: [
            {
                "groupLabel": "",
                "label": "A Collaborative Partner",
                "iframe": true,
                "url": "html/ci-2023/ci-story/trusted-partner.html",
                "useThumb": false,
                "notes": "<p>In line with our long-standing commitment to excellence, we work hand-in-hand with leading clinical and academic partners to bring you the solutions that can help make a positive difference to you and your patients.</p><p>Whether that’s cutting-edge AI-assisted imaging, intelligent healthcare IT, or even education and support, our promise remains the same: we will always help you put the wellbeing of your patients first.\nWith Canon Medical, true innovation is made possible.</p>"
            },
            {
                "label": "Patients",
                "iframe": true,
                "url": "html/ci-2023/ci-story/patients.html",
                "useThumb": false,
                "notes": "Collaborative imaging, is a concept that embodies our mission.<br><br>Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.<br><br>Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  <br><br>AI and data analytics are at the heart of helping to achieve this goal.<br>"
            },
            {
                "label": "People",
                "iframe": true,
                "url": "html/ci-2023/ci-story/people.html",
                "useThumb": false,
                "notes": "Collaborative imaging, is a concept that embodies our mission.<br><br>Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.<br><br>Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  <br><br>AI and data analytics are at the heart of helping to achieve this goal.<br>"
            },
            {
                "label": "Society",
                "iframe": true,
                "url": "html/ci-2023/ci-story/society.html",
                "useThumb": false,
                "notes": "Collaborative imaging, is a concept that embodies our mission.<br><br>Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.<br><br>Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  <br><br>AI and data analytics are at the heart of helping to achieve this goal.<br>"
            },
            {
                "label": "Made for Life",
                "iframe": true,
                "url": "html/ci-2023/ci-story/made-for-life.html",
                "useThumb": false,
                "notes": "Collaborative imaging, is a concept that embodies our mission.<br><br>Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.<br><br>Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  <br><br>AI and data analytics are at the heart of helping to achieve this goal.<br>"
            },


        ]


    },
    csr: {
        id: "csr",
        label: "CSR",
        slides: [
            {
                "groupLabel": "CSR",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/csr.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Sustainability",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/sustainability.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/environmental-impact.html",
                "useThumb": false,
                "notes": ""
            },
            {
                groupLabel: "R&D",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/r-and-d.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/global-partners.html",
                "useThumb": false,
                "notes": ""
            },
            {
                groupLabel: "Communities",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/communities.html",
                "useThumb": false,
                "notes": ""
            },
            {
                groupLabel: "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/we-give-back.html",
                "useThumb": false,
                "notes": ""
            },
            {
                groupLabel: "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/support-something-great.html",
                "useThumb": false,
                "notes": ""
            },
            {
                groupLabel: "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/csr/building-a-more-sustainable-future.html",
                "useThumb": false,
                "notes": ""
            },


        ]


    },
    ai: {
        id: "ai",
        label: "Altivity",
        slides: [
            {
                "groupLabel": "Altivity",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/altivity.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/ai-pillars.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/workflow.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/unlock-the-future.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/ai/partners.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },
    cybersecurity: {
        id: "cybersecurity",
        label: "CYBERSECURITY",
        slides: [
            {
                "groupLabel":"Cybersecurity",
                "label": "Why?",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-solutions-1.html",
                "useThumb": false
            },
            {
                "label": "COVID-19",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-covid-19.html",
                "useThumb": false
            },
            {
                "label": "Impact",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-impact.html",
                "useThumb": false
            },
            {
                groupLabel: "Solutions",
                "label": "Gateway Gold",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-gateway-gold.html",
                "useThumb": false
            },
            {
                "label": "Gateway Platinum",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-gateway-platinum.html",
                "useThumb": false
            },
            {
                "label": "Ease-of-Use",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-ease-of-use.html",
                "useThumb": false
            },
            {
                "label": "Our Priority",
                "iframe": true,
                "url": "html/ci-2023/cybersecurity/cybersecurity-security-priority.html",
                "useThumb": false
            }
        ]
    },
    service: {
        id: "service",
        label: "SERVICE",
        slides: [
            {
                "groupLabel":"Digital Analytics",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/digital-analytics-hero.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/digital-analytics-challenges.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/analytics-dashboard.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/health-check-ct.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/health-check-mr.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/alert-history.html",
                "useThumb": false
            },
            {
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/service/connectivity-dashboard.html",
                "useThumb": false
            }
        ]
    },
    workflow: {
        id: "workflow",
        label: "Clinical Workflow",
        slides: [
            {
                "groupLabel":"Workflow",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/workflow.html",
                "useThumb": false
            },
            {
                "groupLabel":"Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/solutions.html",
                "useThumb": false
            },
            {
                "groupLabel":"",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/workflow-modalities.html",
                "useThumb": false
            },
            {
                "groupLabel":"Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/partners.html",
                "useThumb": false
            },
            {
                "groupLabel":"EI",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/ei.html",
                "useThumb": false
            },
            {
                "groupLabel":"",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/ei-visualization.html",
                "useThumb": false
            },
            {
                "groupLabel":"",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/ei-data-orchestration.html",
                "useThumb": false
            },
            {
                "groupLabel":"",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/ei-workflows.html",
                "useThumb": false
            },
            {
                "groupLabel":"Collaborations",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/workflow/collaborations.html",
                "useThumb": false
            },

        ]
    },
    education: {
        id: "education",
        label: "Education",
        slides: [
            {
                "groupLabel": "Education",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/education/education.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Online Programs",
                "iframe": true,
                "url": "html/ci-2023/education/online-programs.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Training Centers",
                "iframe": true,
                "url": "html/ci-2023/education/training-centers.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Training Programs",
                "iframe": true,
                "url": "html/ci-2023/education/training-programs.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Workshops",
                "iframe": true,
                "url": "html/ci-2023/education/workshops.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },
    sportsmed: {
        id: "sportsmed",
        label: "SPORTSMED",
        slides: [
            {
                "groupLabel": "SportsMed",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/sports-med/sports-med.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "FC Barcelona",
                "iframe": true,
                "url": "html/ci-2023/sports-med/fc-barcelona.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Real Madrid",
                "iframe": true,
                "url": "html/ci-2023/sports-med/real-madrid.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Manchester United",
                "iframe": true,
                "url": "html/ci-2023/sports-med/manchester-united.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Canon Eagles",
                "iframe": true,
                "url": "html/ci-2023/sports-med/canon-eagles.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/sports-med/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/sports-med/sports-for-everyone.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/sports-med/partners.html",
                "useThumb": false,
                "notes": ""
            },


        ]


    },
    lcs: {
        id: "lcs",
        label: "ONCOLOGY",
        slides: [
            {
                "groupLabel": "Lung cancer screening",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/lung-cancer-screening.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/current-challenges.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Mobile imaging",
                "iframe": true,
                "url": "html/ci-2023/lcs/mobile-imaging.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Workflows",
                "iframe": true,
                "url": "html/ci-2023/lcs/workflows.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "SilverBeam + AiCE",
                "iframe": true,
                "url": "html/ci-2023/lcs/silverbeam-aice.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/clinical-1.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/clinical-2.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/clinical-3.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Automated Analysis",
                "iframe": true,
                "url": "html/ci-2023/lcs/automated-analysis.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/lcs/partners.html",
                "useThumb": false,
                "notes": ""
            },


        ]


    },
    womenshealth: {
        id: "womenshealth",
        label: "WOMEN'S HEALTH",
        slides: [
            {
                "groupLabel": "Women's Health",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/womens-health.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Obstetrics",
                "iframe": true,
                "url": "html/ci-2023/womens-health/obstetrics.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Gynecology",
                "iframe": true,
                "url": "html/ci-2023/womens-health/gynecology.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Assisted reproduction",
                "iframe": true,
                "url": "html/ci-2023/womens-health/assisted-reproduction-1.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/assisted-reproduction-2.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Breast imaging",
                "iframe": true,
                "url": "html/ci-2023/womens-health/breast-imaging-1.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/breast-imaging-2.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/partners.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Products",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/womens-health/products.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },
    msk: {
        id: "msk",
        label: "MSK",
        slides: [
            {
                "groupLabel": "MSK",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/msk/msk.html",
                "image": "html/ci-2023/msk/images/MSK.webp",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/msk/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "X-ray",
                "iframe": true,
                "url": "html/ci-2023/msk/x-ray.html",
                "useThumb": false,
                "notes": "",
                "image": "html/ci-2023/msk/images/X-ray.webp",
                "html": `<div class="ci-slide bg-black fade-on-load transition-opacity duration-300" style="transition:0.3s opacity;">
                            <img class="absolute w-full h-full cover" width="100%" height="100%" src="html/ci-2023/msk/images/X-ray.webp">
                        </div>`
            },
            {
                "groupLabel": "",
                "label": "UL",
                "iframe": true,
                "url": "html/ci-2023/msk/ul.html",
                "useThumb": false,
                "html": `
                <div class="ci-slide bg-black fade-on-load transition-opacity duration-300 relative" style="opacity:1;transition:0.3s opacity;">
                    <img class="absolute w-full h-full cover" width="100%" height="100%" src="html/ci-2023/msk/images/UL.webp">
                    <div class="" style="position: absolute; width:36.15%; height:44.81%; left: 4.95%; top: 37.69%;">
                        <video autoplay muted playsinline loop style="width:100%;height:100%; object-fit: cover; object-position: bottom;">
                            <source src="html/ci-2023/msk/graphics/MSK-2.mp4" type="video/mp4">
                        </video>
                    </div>
                </div>`,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "CT",
                "iframe": true,
                "url": "html/ci-2023/msk/ct.html",
                "useThumb": false,
                "notes": "",
                "html": `<div class="ci-slide bg-black fade-on-load transition-opacity duration-300" style="opacity:1;transition:0.3s opacity;">
                            <img class="absolute w-full h-full cover" width="100%" height="100%" src="html/ci-2023/msk/images/CT.webp">
                            <div class="video-container" style="position: absolute; width:25.94%; left: 55.68%; top: 36.76%;">
                                <video autoplay muted playsinline loop style="width:100%;"  placeholder="html/ci-2023/msk/graphics/4dct-placeholder.jpg">
                                    <source src="html/ci-2023/msk/graphics/4D-CT-video.mp4" type="video/mp4">
                                </video>
                            </div>
                        </div>`
            },
            {
                "groupLabel": "",
                "label": "MRI",
                "iframe": true,
                "url": "html/ci-2023/msk/mri.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Advanced Visualization",
                "iframe": true,
                "url": "html/ci-2023/msk/advanced-visualization.html",
                "useThumb": false,
                "notes": ""
            },

            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/msk/partners.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Products",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/msk/products.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },
    cardiology: {
        id: "cardiology",
        label: "CARDIOLOGY",
        slides: [
            {
                "groupLabel": "Cardiology",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/cardiology.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Diagnosis",
                "label": "Workflows",
                "iframe": true,
                "url": "html/ci-2023/cardiology/workflows.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Coronary",
                "iframe": true,
                "url": "html/ci-2023/cardiology/coronary-imaging.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Myocardial",
                "iframe": true,
                "url": "html/ci-2023/cardiology/myocardial-imaging-1.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/myocardial-imaging-2.html",
                "useThumb": false,
                "notes": ""
            },

            {
                "groupLabel": "",
                "label": "Imaging integration",
                "iframe": true,
                "url": "html/ci-2023/cardiology/imaging-integration.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Intervention",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/intervention.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "Advanced Visualization",
                "iframe": true,
                "url": "html/ci-2023/cardiology/advanced-visualization.html",
                "useThumb": false,
                "notes": ""
            },


            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/partners-1.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/partners-2.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Products",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/cardiology/products.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },
    stroke: {
        id: "stroke",
        label: "NEUROLOGY",
        slides: [
            {
                "groupLabel": "Stroke",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/stroke.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Solutions",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/solutions.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Scanning",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/scanning-ct.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/scanning-mri.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Diagnosis",
                "label": "AI",
                "iframe": true,
                "url": "html/ci-2023/stroke/ai.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/diagnosis-2.html",
                "useThumb": false,
                "notes": ""
            },

            {
                "groupLabel": "Treatment",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/treatment.html",
                "useThumb": false,
                "html":`
<div class="ci-slide bg-black fade-on-load transition-opacity duration-300" style="opacity:1;transition:0.3s opacity;">
    <img class="absolute w-full h-full cover" width="100%" height="100%" src="html/ci-2023/stroke/images/Treatment.webp">
    <div class="video-container" style="position: absolute; width:34.48%; height:61.3%; left: 58.28%; top: 23.15%;">
        <video autoplay muted playsinline loop style="width:100%;height:100%;" height="720" height="720" class="w-full" placeholder="./graphics/4dct-placeholder.jpg">
            <source src="html/ci-2023/stroke/graphics/hi-def-stent-assisted-coiling.mp4" type="video/mp4">
        </video>
    </div>
</div>`,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "One room",
                "iframe": true,
                "url": "html/ci-2023/stroke/one-room.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "4D CT",
                "iframe": true,
                "url": "html/ci-2023/stroke/4D-CT.html",
                "useThumb": false,
                "notes": ""
            },


            {
                "groupLabel": "Follow up",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/follow-up.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "",
                "label": "UL SMI",
                "iframe": true,
                "url": "html/ci-2023/stroke/ul-smi.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Partners",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/partners.html",
                "useThumb": false,
                "notes": ""
            },
            {
                "groupLabel": "Products",
                "label": "",
                "iframe": true,
                "url": "html/ci-2023/stroke/products.html",
                "useThumb": false,
                "notes": ""
            },



        ]


    },



}